// Types
import { TextComponentType } from '@kubit/web-ui-components';
const paragraphConfigurationPropsConversion = (props) => ({
    children: props.children,
    component: props.component ?? TextComponentType.PARAGRAPH,
    color: props?.color ?? undefined,
    customTypography: props?.customTypography ?? props?.styles?.typography,
    dataTestId: props?.testId,
    id: props?.testId,
    role: props.role ?? undefined,
    variant: props?.type,
});
export { paragraphConfigurationPropsConversion };
//# sourceMappingURL=paragraph.configuration.js.map